import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChats = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		stroke: "null",
		transform: "rotate(0.35051098465919495 11.000000000000743,10.999999999999918) ",
		fillRule: "nonzero",
		d: "m19.1,5.6l-1.8,0l0,8.1l-11.7,0l0,1.8c0,0.495 0.405,0.9 0.9,0.9l9.9,0l3.6,3.6l0,-13.5c0,-0.495 -0.405,-0.9 -0.9,-0.9zm-3.6,5.4l0,-8.1c0,-0.495 -0.405,-0.9 -0.9,-0.9l-11.7,0c-0.495,0 -0.9,0.405 -0.9,0.9l0,12.6l3.6,-3.6l9,0c0.495,0 0.9,-0.405 0.9,-0.9z"
	})
});
export default SvgChats;
